<questionnaire-form-displayer
    [userFormDetails]="userFormDetails"
    [comfirmOnClose]="canClose"
    [printMode]="printMode"
    [masterComplete]="masterComplete"
    [close]="canClose ? this.close : null"
    [printUrl]="'/print/questionnaire/user-form/' + userFormDetails.UserForm.UserFormId"
    (onSubmissionComplete)="submissionComplete($event)"
></questionnaire-form-displayer>
